import { Component, Input, OnInit } from '@angular/core';
import { Dashboard } from '../dashboard.models';

@Component({
  selector: 'app-b2b-top-categories',
  template: `<app-top-chart [dashboardData]="dashboardData" [mainField]="mainField" [fields]="fields" [icon]="icon"></app-top-chart>`
})
export class B2bTopCategoriesComponent implements OnInit {
  @Input('dashboardData') dashboardData: Dashboard;
  mainField: string = 'category';
  icon: string = 'ti-menu-alt';
  fields = [
    {
      header: 'DASHBOARD.ORDERED_QUANTITY',
      value: 'orderedQuantity',
      type: 'decimal'
    },
    {
      header: 'DASHBOARD.ORDER_VALUE',
      value: 'orderedValue',
      type: 'decimal'
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
